import React from 'react';

import Styles from './SummaryTile.styles';

interface Props {
  featureName?: string
  isMonthly: boolean,
}

export const SauceFeature: React.FC<Props> = ({ featureName, isMonthly }) => {
  let cadence = `${isMonthly ? 'Monthly' : 'Annual'} plan`;
  if (featureName) {
    cadence = `(${cadence})`;
  }
  return (
    <div className="text-gray-600">
      {featureName}
      <span className={Styles['text-thin']}>
        {` ${cadence}`}
      </span>
    </div>
  );
};
